import { Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Subscription } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-dailog-replace-car',
  templateUrl: './dailog-replace-car.component.html',
  styleUrls: ['./dailog-replace-car.component.scss',],
})
export class DailogReplaceCarComponent {
  public onClose: Subject<boolean> = new Subject();

  faTimes = faTimes;
  subscription?: Subscription;
  
  constructor(
    private _bsModalRef: BsModalRef
  ) { }

  closeModal() {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  confirm() {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

}
